/**
 * @file
 * Behaviors for the Counter component.
 */

!((Drupal) => {
  'use strict';

  /**
   * Setup and attach the Counter behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.counter = {
    attach: function() {
      const animateValue = (targetId, start, end, duration) => {
        const target = document.getElementById(targetId);
        const range = end - start;
        const minimumTimer = 50;
        let stepTime = Math.abs(Math.floor(duration / range));

        stepTime = Math.max(stepTime, minimumTimer);

        const startTime = new Date().getTime();
        const endTime = startTime + duration;
        let timer;

        const run = () => {
          const now = new Date().getTime();
          const remaining = Math.max((endTime - now) / duration, 0);
          const value = Math.round(end - remaining * range);
          if (target) {
            target.innerHTML = value;
          }
          if (value === end) {
            clearInterval(timer);
          }
        };

        timer = setInterval(run, stepTime);
        run();
      };

      const targets = document.querySelectorAll('.mss-counter--number');
      const delay = parseInt(
        document.querySelector('.mss-counter').getAttribute('data-delay')
      );

      for (let i = 0; i < targets.length; i++) {
        const target = targets[i].getAttribute('id');
        const startNumber = parseInt(
          targets[i].getAttribute('data-start-number')
        );
        const endNumber = parseInt(targets[i].getAttribute('data-end-number'));
        const duration = parseInt(targets[i].getAttribute('data-duration'));

        // delay starting the countdowns in case people need to scroll down
        setTimeout(() => {
          animateValue(target, startNumber, endNumber, duration);
        }, delay);
      }
    }
  };
})(Drupal);
